<template>
  <div class="chat-group-list-wrapper">
    <div class="header-morph-container" :style="{ height: `${currentHeaderHeight}px` }">
      <div class="header-large-content" :style="{ opacity: largeContentOpacity }">
        <v-btn icon dark absolute top left large class="mt-2 ml-1 glass-btn" @click="$router.push('/')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        
        <img class="ml-2 logo-glow" :height="largeIconSize" src="/img/einmalig/roodyChatLogo.png"></img>
        
        <v-menu v-if="userService.hasRight('chat_create') || userService.hasRight('chat_broadcasts') || userService.hasRight('chat_admin')" offset-y left content-class="glass-menu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="hasCreateRight" top right absolute icon v-bind="attrs" v-on="on" class="glass-btn mt-2 mr-1">
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list dense dark >
            <v-list-item v-if="userService.hasRight('chat_create')" @click="$emit('open-create-dialog')">
              <v-list-item-icon><v-icon>mdi-account-group-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Neue Gruppe</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="hasDirectChatRight" @click="$emit('open-direct-dialog')">
              <v-list-item-icon><v-icon>mdi-chat-plus-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Einzelchat starten</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="userService.hasRight('chat_broadcasts')" @click="$emit('open-broadcast-dialog')">
              <v-list-item-icon><v-icon>mdi-bullhorn-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Rundsendung</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-toolbar dark flat color="transparent" class="header-small-toolbar" :style="{ opacity: smallToolbarOpacity }">
        <v-btn icon @click="$router.push('/')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0 font-weight-bold" style="font-size: 1.1rem; letter-spacing: 0.5px">Chats</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y left content-class="glass-menu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="hasCreateRight" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list dense dark>
            <v-list-item @click="$emit('open-create-dialog')">
              <v-list-item-icon><v-icon>mdi-account-group-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Neue Gruppe</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="hasDirectChatRight" @click="$emit('open-direct-dialog')">
              <v-list-item-icon><v-icon>mdi-chat-plus-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Einzelchat starten</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('open-broadcast-dialog')">
              <v-list-item-icon><v-icon>mdi-bullhorn-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Rundsendung</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>

    <v-toolbar flat dense dark color="transparent" class="search-bar-absolute" :style="{ top: `${currentHeaderHeight}px` }">
      <v-text-field
        v-model="searchQuery"
        placeholder="Suchen..."
        filled
        rounded
        dense
        hide-details
        dark
        clearable
        prepend-inner-icon="mdi-magnify"
        class="glass-search-field enhanced-search"
      ></v-text-field>
    </v-toolbar>

    <div ref="scrollContainer" class="group-list-scroll-area custom-scrollbar" @scroll="handleScroll">
      <div class="content-spacer" :style="{ height: `${currentSpacerHeight}px` }"></div>

      <div v-if="isLoadingGroups" class="pa-2">
        <v-skeleton-loader
          v-for="n in 8"
          :key="n"
          type="list-item-avatar-two-line"
          class="mb-2 glass-skeleton"
          dark
        ></v-skeleton-loader>
      </div>

      <div class="group-list-content pa-2">
        
        <v-card
          @click="openPinboard"
          dark
          rounded="xl"
          class="mb-3 glass-card pinboard-card"
          :class="{ 'active-group-card': activeView === 'pinboard' }"
          elevation="0">
          <v-list-item class="pa-3">
            <v-list-item-avatar color="rgba(255, 193, 7, 0.2)" class="pulsing-avatar-wrapper">
               <v-icon color="amber lighten-2">mdi-pin-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-black amber--text text--lighten-3" style="letter-spacing: 0.5px">
                PINBOARD
              </v-list-item-title>
              <v-list-item-subtitle class="caption grey--text text--lighten-1">
                Deine gemerkten Nachrichten
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon small color="amber darken-3">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-card>

        <v-card
          @click="openSupportChat"
          dark
          rounded="xl"
          class="mb-3 glass-card support-card"
          elevation="0">
          <v-list-item class="pa-3">
            <v-list-item-avatar color="rgba(33, 150, 243, 0.2)">
               <v-icon color="blue lighten-2">mdi-face-agent</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-black blue--text text--lighten-3" style="letter-spacing: 0.5px">
                APP SUPPORT
              </v-list-item-title>
              <v-list-item-subtitle class="caption grey--text text--lighten-1">
                Hilfe &amp; Feedback – wir sind für dich da
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon small color="blue darken-3">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-card>

        <div v-if="!isLoadingGroups && chatGroups.length > 0 && filteredGroups.length === 0" class="text-center grey--text pa-8">
          <v-icon size="60" color="grey darken-3" class="mb-3">mdi-magnify-remove-outline</v-icon>
          <p class="body-2">Keine Chats gefunden.</p>
        </div>

        <transition-group name="staggered-list" tag="div">
          <v-card
            v-for="(group, index) in filteredGroups"
            :key="group ? group._id : 'empty-' + index"
            v-if="group"
            @click="selectGroup(group._id)"
            dark
            rounded="xl"
            class="mb-2 glass-card group-card"
            :class="{ 'active-group-card': group._id === activeGroupId }"
            elevation="0"
          >
            <v-list-item class="pa-3">
              <div class="avatar-container mr-3">
                <v-avatar size="48" :class="{ 'online-ring': isGroupOnline(group) }">
                  <v-img v-if="getDisplayAvatar(group)" :src="getDisplayAvatar(group)" alt="Gruppenbild"></v-img>
                  <div v-else class="fallback-avatar d-flex align-center justify-center primary darken-3 fill-height" style="width: 100%">
                    <span class="white--text font-weight-bold headline">{{ getGroupInitials(getDisplayName(group)) }}</span>
                  </div>
                </v-avatar>
                <div v-if="isGroupOnline(group)" class="online-dot"></div>
              </div>

              <v-list-item-content>
                <div class="d-flex justify-space-between align-center mb-1">
                  <v-list-item-title v-text="getDisplayName(group)" class="font-weight-bold text-body-1 white--text"></v-list-item-title>
                  <span class="caption grey--text text--darken-1 flex-shrink-0 ml-2">
                    {{ formatLastMessageTime(group.lastMessage && group.lastMessage.createdAt) }}
                  </span>
                </div>

                <div class="d-flex justify-space-between align-center">
                   <v-list-item-subtitle class="text-truncate body-2 pr-2" :class="{ 'typing-text': getTypingData(group).isTyping, 'grey--text text--lighten-1': !getTypingData(group).isTyping }">
                    <span v-if="getTypingData(group).isTyping">
                       <v-icon x-small color="primary" class="mr-1 blink-anim">mdi-pencil</v-icon>
                       {{ getTypingData(group).text }}
                     </span>
                     <span v-else>
                       {{ getSubtitle(group) }}
                     </span>
                  </v-list-item-subtitle>
                  
                  <div v-if="group.hasUnread" class="unread-badge-pill elevation-5">
                     <span v-if="group.isMentioned" class="mention-at">@</span>
                     <span v-else class="unread-dot"></span>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

import userService from "@/services/userService"
const MIN_HEADER_HEIGHT = 56
const SEARCH_BAR_HEIGHT = 56

export default {
  name: "ChatGroupList",
  props: {
    hasCreateRight: { type: Boolean, default: false },
    hasDirectChatRight: { type: Boolean, default: false },
  },
  data() {
    return {
      searchQuery: "",
      scrollTop: 0,
      maxHeaderHeight: 200,
      userService,
    }
  },
  mounted() {
    this.maxHeaderHeight = window.innerHeight * 0.25 
  },
  computed: {
    ...mapState("userStore", ["user"]),
    ...mapState("chatStore", ["chatGroups", "activeGroupId", "isLoadingGroups", "typingUsers", 'activeView']),
    ...mapGetters("chatStore", ["getPresenceByUserId"]),

    scrollProgress() {
      const scrollRange = this.maxHeaderHeight - MIN_HEADER_HEIGHT
      if (scrollRange <= 0) return 1
      return Math.max(0, Math.min(1, this.scrollTop / scrollRange))
    },
    currentHeaderHeight() {
      const heightDiff = this.maxHeaderHeight - MIN_HEADER_HEIGHT
      return this.maxHeaderHeight - heightDiff * this.scrollProgress
    },
    currentSpacerHeight() {
      return this.maxHeaderHeight + SEARCH_BAR_HEIGHT
    },
    largeContentOpacity() {
      const FADE_END = 0.7 
      return Math.max(0, 1 - this.scrollProgress / FADE_END)
    },
    smallToolbarOpacity() {
      const FADE_START = 0.5 
      const FADE_DURATION = 1 - FADE_START
      return Math.max(0, (this.scrollProgress - FADE_START) / FADE_DURATION)
    },
    largeIconSize() {
      return 100 - this.scrollProgress * 100
    },
    filteredGroups() {
      const SUPPORT_DEV_IDS = [
        "5f55fdad6716c132adf93baa",
        "6110f9ddd2d4d90279c938d3",
      ]
      const myId = this.user ? this.user._id : null
      const isDev = SUPPORT_DEV_IDS.includes(myId)

      let groups = this.chatGroups
      // Für normale User: Support-Gruppen aus der Liste filtern (nur über den SUPPORT-Button erreichbar)
      if (!isDev) {
        groups = groups.filter((g) => !g.isSupport)
      }

      const query = (this.searchQuery || "").toLowerCase().trim()
      if (!query) {
        return groups
      }
      return groups.filter((group) => {
        if (!group || !group.name) return false
        const searchName = this.getDisplayName(group).toLowerCase()
        return searchName.includes(query)
      })
    },
  },

  methods: {
    ...mapActions("chatStore", {
      selectGroup: "setActiveGroup",
      openPinboard: "openPinboard",
      openSupportChat: "openSupportChat"
    }),

    handleScroll(event) {
      this.scrollTop = event.target.scrollTop
    },

    getGroupInitials(name) {
      if (!name) return "G"
      const parts = name.trim().split(' ')
      if (parts.length > 1) return (parts[0][0] + parts[1][0]).toUpperCase()
      return name.substring(0,2).toUpperCase()
    },

    getOtherMember(group) {
      if (!group || !group.members || !this.user) return null
      return group.members.find((m) => m.userId && (m.userId._id || m.userId) !== this.user._id)
    },

    getDisplayAvatar(group) {
      if (group.isDirect) {
        const other = this.getOtherMember(group)
        return other && other.userId && other.userId.bild ? '/img/profilbilder/' + other.userId.bild : null
      }
      return group.bild ? '/img/profilbilder/' + group.bild : null
    },

    getDisplayName(group) {
      if (group.isDirect) {
        const other = this.getOtherMember(group)
        return other && other.userId ? `${other.userId.vorname} ${other.userId.nachname}` : 'Gelöschter Nutzer'
      }
      return group.name
    },

    isGroupOnline(group) {
      if (!group || !group.members) return false
      return group.members.some((member) => {
        if (!member.userId || (member.userId._id || member.userId) === this.user._id) return false
        const presence = this.getPresenceByUserId(member.userId._id)
        return presence && presence.isOnline
      })
    },

    formatLastMessageTime(timestamp) {
      if (!timestamp) return ""
      const date = new Date(timestamp)
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(yesterday.getDate() - 1)
      if (date.toDateString() === today.toDateString()) {
        return date.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" })
      }
      if (date.toDateString() === yesterday.toDateString()) {
        return "Gestern"
      }
      return date.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit" })
    },

    getTypingData(group) {
      if (!this.typingUsers || !this.user || !group.members) {
        return { isTyping: false, text: "" }
      }
      const typingIds = this.typingUsers[group._id] || []
      const tippers = group.members.filter((member) => typingIds.includes(member.userId._id) && member.userId._id !== this.user._id)
      const count = tippers.length
      if (count === 0) return { isTyping: false, text: "" }
      let text = ""
      if (count === 1) text = `${tippers[0].userId.vorname} schreibt...`
      else text = "Mehrere Personen schreiben..."
      return { isTyping: true, text: text }
    },

    getSubtitle(group) {
      if (group.lastMessage && group.lastMessage.textContent) {
        const sender = group.lastMessage.senderId
        const text = group.lastMessage.textContent
        if (sender && this.user && sender._id === this.user._id) {
          return `Du: ${text}`
        }
        if (sender && sender.vorname) {
          return `${sender.vorname}: ${text}`
        }
        return text
      }
      if (group.lastMessage && group.lastMessage.fileInfo) {
         const sender = group.lastMessage.senderId
         const name = (sender && sender._id === this.user._id) ? 'Du' : (sender ? sender.vorname : 'Jemand')
         return `${name} hat eine Datei gesendet`
      }
      const memberCount = group.members ? group.members.length : 0
      return `${memberCount} Mitglieder`
    },
  },
}
</script>

<style lang="scss" scoped>
/* BACKGROUND & LAYOUT */
.chat-group-list-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #0d0d0d; /* Richtig tiefes Schwarz */
  /* Ein feiner Mesh-Gradient im Hintergrund */
  background-image: 
    radial-gradient(circle at 10% 20%, rgba(0, 150, 63, 0.05) 0%, transparent 40%),
    radial-gradient(circle at 90% 80%, rgba(20, 20, 20, 0.8) 0%, transparent 40%);
}

/* HEADER */
.header-morph-container {
  position: absolute;
  top: 0; left: 0; right: 0;
  z-index: 10;
  will-change: height;
  overflow: hidden;
  background: rgba(13, 13, 13, 0.85); /* Fast undurchsichtig */
  backdrop-filter: blur(20px) saturate(180%);
  border-bottom: 1px solid rgba(255,255,255,0.05);
  box-shadow: 0 10px 30px -10px rgba(0,0,0,0.5);
}

.header-large-content {
  display: flex; align-items: center; justify-content: center;
  height: 100%; width: 100%; position: absolute; top: 0; left: 0;
}
.header-small-toolbar {
  position: absolute; bottom: 0; left: 0; width: 100%;
  background: transparent !important;
}

/* LOGO GLOW */
.logo-glow {
  filter: drop-shadow(0 0 15px rgba(0, 150, 63, 0.4));
  transition: transform 0.3s ease;
}

/* SEARCH BAR */
.search-bar-absolute {
  position: absolute; left: 0; right: 0; z-index: 9;
  background: transparent;
  padding: 0 8px;
}
.glass-search-field {
  ::v-deep .v-input__slot {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
  }
  ::v-deep .v-input__slot:focus-within {
    background: rgba(255, 255, 255, 0.1) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    box-shadow: 0 0 20px rgba(0,0,0,0.4);
  }
}

/* SCROLLER */
.group-list-scroll-area {
  height: 100%; width: 100%;
  overflow-y: auto; overflow-x: hidden;
  position: relative; z-index: 1;
}

/* CARDS - DAS HIGHLIGHT */
.glass-card {
  /* High-End Glassmorphism */
  background: rgba(255, 255, 255, 0.025) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  backdrop-filter: blur(10px);
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;

  /* Subtiler Glow bei Hover */
  &::before {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    background: radial-gradient(circle at center, rgba(255,255,255,0.05), transparent 70%);
    opacity: 0; transition: opacity 0.3s;
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-2px) scale(1.01);
    background: rgba(255, 255, 255, 0.05) !important;
    border-color: rgba(255, 255, 255, 0.15) !important;
    box-shadow: 0 10px 25px -5px rgba(0,0,0,0.5);

    &::before { opacity: 1; }
  }
}

/* ACTIVE STATE */
.active-group-card {
  background: linear-gradient(135deg, rgba(0, 150, 63, 0.15), rgba(0, 150, 63, 0.05)) !important;
  border: 1px solid rgba(0, 150, 63, 0.5) !important;
  box-shadow: 0 0 20px rgba(0, 150, 63, 0.2), inset 0 0 20px rgba(0, 150, 63, 0.1) !important;
}

/* PINBOARD CARD SPECIAL */
.pinboard-card {
  border: 1px solid rgba(255, 193, 7, 0.2) !important;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.05), transparent) !important;
}
.pinboard-card:hover {
  border-color: rgba(255, 193, 7, 0.5) !important;
  box-shadow: 0 0 15px rgba(255, 193, 7, 0.2);
}

/* SUPPORT CARD SPECIAL */
.support-card {
  border: 1px solid rgba(33, 150, 243, 0.2) !important;
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.05), transparent) !important;
}
.support-card:hover {
  border-color: rgba(33, 150, 243, 0.5) !important;
  box-shadow: 0 0 15px rgba(33, 150, 243, 0.2);
}

/* AVATAR & STATUS */
.avatar-container {
  position: relative;
  display: inline-block;
}
/* Pulsierender Ring für Online User */
.online-ring {
  border: 2px solid #00E676; /* Helles Grün */
  box-shadow: 0 0 0 2px rgba(0,0,0,0.5); /* Abstandhalter */
  animation: pulse-ring 2s infinite;
}
@keyframes pulse-ring {
  0% { box-shadow: 0 0 0 0 rgba(0, 230, 118, 0.7); }
  70% { box-shadow: 0 0 0 6px rgba(0, 230, 118, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 230, 118, 0); }
}

.online-dot {
  position: absolute;
  bottom: 0; right: 0;
  width: 14px; height: 14px;
  background: #00E676;
  border: 2px solid #121212;
  border-radius: 50%;
}

.fallback-avatar {
  background: linear-gradient(135deg, #333, #111);
}

/* TYPOGRAPHY */
.typing-text {
  color: var(--v-primary-base) !important;
  font-style: italic;
  font-weight: 500;
}
.blink-anim {
  animation: blink 1s infinite;
}
@keyframes blink { 50% { opacity: 0.5; } }

/* UNREAD BADGE */
.unread-badge-pill {
  min-width: 20px; height: 20px;
  background: var(--v-primary-base);
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  padding: 0 6px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.5);
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.unread-dot {
  width: 8px; height: 8px; background: white; border-radius: 50%;
}
.mention-at {
  font-weight: 900; font-size: 12px; color: white;
}
@keyframes popIn {
  from { transform: scale(0); } to { transform: scale(1); }
}

/* SCROLLBAR */
.custom-scrollbar::-webkit-scrollbar { width: 5px; }
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.1); border-radius: 10px;
}

/* BUTTONS */
.glass-btn {
  background: rgba(255,255,255,0.05) !important;
  backdrop-filter: blur(5px);
  &:hover { background: rgba(255,255,255,0.15) !important; }
}

/* LIST TRANSITIONS */
.staggered-list-enter-active, .staggered-list-leave-active {
  transition: all 0.3s ease;
}
.staggered-list-enter {
  opacity: 0; transform: translateY(20px);
}
.staggered-list-leave-to {
  opacity: 0; transform: scale(0.9);
}
</style>